import { Component, type OnInit, inject } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { type HotkeyGroup, HotkeysService } from "@ngneat/hotkeys";

@Component({
    selector: "app-hotkey-help-modal",
    templateUrl: "./hotkey-help-modal.component.html",
    styleUrls: ["./hotkey-help-modal.component.scss"],
    imports: [],
})
export class HotkeyHelpModalComponent implements OnInit {
    activeModal = inject(NgbActiveModal);
    private hotkeyService = inject(HotkeysService);

    static readonly casuallyDismissible = true;
    groups: HotkeyGroup[];

    ngOnInit(): void {
        this.groups = this.hotkeyService.getShortcuts();
    }
}
